export const EQUIPMENT_KPI_REQUEST_STALE_TIME = 1000 * 60 * 15